import React, { useEffect, useState } from 'react';
import { showUserRewardDialog } from 'lib/components/UserRewardDialog';
import { getLoginType, markPromptShown, shouldShowPrompt } from 'lib/utils/util';
import { ENV_TYPE } from 'lib/constants/login';
import { DELIVER_STATUS, SHOW_STATUS_TYPE_ARRAY } from 'lib/constants/award';
import { BenefitRecordAwardStatus } from 'lib/constants/fragment';
import { showThirdPartyLogin } from 'lib/components/ThirdPartyLogin';
import { useUserRewardStore } from 'lib/store/userRewardStore';
import { useMobileStore } from 'lib/store/mobileStore';
import { useFinishInit } from 'lib/hooks/useFinishInit';
import './styles.scss';

export default function UserRewardButton({ data, commonStyle }) {
  const { btnImg, freeLotteryId, lotteryActivityId } = data;
  const { queryCommonPrizeResult, commonPrizeResult } = useUserRewardStore((state) => state);
  const [showRedPoint, setShowRedPoint] = useState(false);
  const { inputMobile } = useMobileStore((state) => state);

  useFinishInit(() => {
    const loginType = getLoginType();
    const isLoggedIn = loginType !== ENV_TYPE.GUEST;
    isLoggedIn && handleLotteryResultShow();
  });

  useEffect(() => {
    handleRedPonitStatus();
  }, [commonPrizeResult]);

  const existUnReceivedPrize = (prizeList) => {
    if (!prizeList?.length) return false;
    return prizeList?.some((item) => {
      const { prizeType, deliverStatus, recordStatus } = item;
      if (
        SHOW_STATUS_TYPE_ARRAY.includes(prizeType) &&
        deliverStatus !== DELIVER_STATUS.DELIVERED &&
        recordStatus !== BenefitRecordAwardStatus.Delivered
      ) {
        return true;
      }
    });
  };

  const handleLotteryResultShow = async () => {
    const prizeRes = await queryCommonPrizeResult(inputMobile, true);
    const hasUnReceived = existUnReceivedPrize(prizeRes);
    if (hasUnReceived && shouldShowPrompt(`lotteryResultShow`)) {
      markPromptShown('lotteryResultShow');
      showLotteryResult();
    }
  };

  const handleRedPonitStatus = async () => {
    const hasUnReceived = existUnReceivedPrize(commonPrizeResult);
    setShowRedPoint(hasUnReceived && shouldShowPrompt(`lotteryResultClick`));
  };

  const showLotteryResult = (e?) => {
    if (e) {
      markPromptShown('lotteryResultClick');
      setShowRedPoint(false);
    }
    const loginType = getLoginType();
    if (loginType === ENV_TYPE.GUEST) {
      showThirdPartyLogin({
        isBinding: false,
      });
      return;
    }
    showUserRewardDialog({ freeLotteryId, lotteryActivityId, title: e ? '' : '您有待领取的奖励' });
  };

  return (
    <div className="user-rewards-btn" style={commonStyle} onClick={showLotteryResult} data-test-id="user-reward-button">
      {showRedPoint && <div className="synthesis" />}
      {btnImg ? <img className="btn-img" src={btnImg} /> : null}
    </div>
  );
}
